import { render, staticRenderFns } from "./AsciiTerminalPreview.vue?vue&type=template&id=20c74b18&scoped=true&"
import script from "./AsciiTerminalPreview.vue?vue&type=script&lang=ts&"
export * from "./AsciiTerminalPreview.vue?vue&type=script&lang=ts&"
import style0 from "./AsciiTerminalPreview.vue?vue&type=style&index=0&id=20c74b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c74b18",
  null
  
)

export default component.exports